import { type CalculateTimeLeftResult, calculateTimeLeft } from '../utils';
import { useEffect, useMemo, useState } from 'react';

export const useCountDown = (minutes: number, onTimeUp?: () => void) => {
    const timeTo = useMemo(() => {
        const currentDate = new Date();
        currentDate.setMinutes(currentDate.getMinutes() + minutes);
        return currentDate.toISOString();
    }, [minutes]);

    const [timeLeft, setTimeLeft] = useState<CalculateTimeLeftResult>(calculateTimeLeft(timeTo));

    useEffect(() => {
        if (timeLeft.isTimeUp && timeLeft.isValidDate) {
            if (onTimeUp) {
                onTimeUp();
            }
            return;
        }
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(timeTo));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, onTimeUp, timeTo]);

    return { timeLeft };
};
